// class PercorsiHandlerClass extends elementorModules.frontend.handlers.Base {
//   getDefaultSettings() {
//     return {
//       selectors: {
//         firstSelector: ".firstSelectorClass",
//         secondSelector: ".secondSelectorClass",
//       },
//     };
//   }

//   getDefaultElements() {
//     const selectors = this.getSettings("selectors");
//     return {
//       $firstSelector: this.$element.find(selectors.firstSelector),
//       $secondSelector: this.$element.find(selectors.secondSelector),
//     };
//   }

//   bindEvents() {
//     this.elements.$firstSelector.on(
//       "click",
//       this.onFirstSelectorClick.bind(this)
//     );
//   }

//   onFirstSelectorClick(event) {
//     event.preventDefault();

//     this.elements.$secondSelector.show();
//   }
// }

document.addEventListener("DOMContentLoaded", function () {
  $(".percorsi__slider").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    prevArrow: ".percorsi__categories__prev",
    nextArrow: ".percorsi__categories__next",
    responsive: [
      {
        breakpoint: 1216,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
          dots: true,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
  });
});
